import { api } from "../lib";
import type {
  AssignmentNotice,
  AssignmentNoticePage,
} from "../types/casePathologistAssignment";

export interface AssignmentNoticeListOptions {
  after?: string;
  cursor?: string;
  unreadOnly?: boolean;
  limit?: number;
}

export const notificationsService = {
  getPathologistAssignmentNotices: async (
    options: AssignmentNoticeListOptions = {}
  ): Promise<AssignmentNoticePage> => {
    const params = new URLSearchParams();
    if (options.after) params.set("after", options.after);
    if (options.cursor) params.set("cursor", options.cursor);
    if (options.unreadOnly !== undefined) {
      params.set("unreadOnly", String(options.unreadOnly));
    }
    params.set("limit", String(options.limit ?? 20));
    return api.get<AssignmentNoticePage>(
      `/notifications/pathologist-assignments?${params.toString()}`
    );
  },

  markPathologistAssignmentNoticeRead: async (
    notificationId: string
  ): Promise<AssignmentNotice> => {
    return api.patch<AssignmentNotice>(
      `/notifications/pathologist-assignments/${notificationId}/read`
    );
  },
};
